module.exports = __webpack_public_path__ + "static/media/9 (1).0239f1b1.webp";